import { render, staticRenderFns } from "./Categories-dedicated.vue?vue&type=template&id=d0ca3172&scoped=true"
import script from "./Categories-dedicated.vue?vue&type=script&lang=js"
export * from "./Categories-dedicated.vue?vue&type=script&lang=js"
import style0 from "./Categories-dedicated.vue?vue&type=style&index=0&id=d0ca3172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ca3172",
  null
  
)

export default component.exports